import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=2af99abc&scoped=true"
import script from "./medical.vue?vue&type=script&lang=js"
export * from "./medical.vue?vue&type=script&lang=js"
import style0 from "./medical.vue?vue&type=style&index=0&id=2af99abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af99abc",
  null
  
)

export default component.exports